import { render, staticRenderFns } from "./giftlist.vue?vue&type=template&id=4972f11c&scoped=true"
import script from "./giftlist.vue?vue&type=script&lang=js"
export * from "./giftlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972f11c",
  null
  
)

export default component.exports